import { ImageIcon } from "lucide-react";
import { ModuleHeader } from "./VideoCarousel";
import { resolveMedia } from "@/api/client";

// A clean single row of images (Global Impact / Feast / Virtual Altar). Empty
// slots render as tasteful placeholder tiles until an admin uploads photos.
export const Gallery = ({ module }) => {
  const images = module.images && module.images.length ? module.images : ["", "", "", ""];
  return (
    <div data-testid={`journey-gallery-${module.id}`} className="mx-auto max-w-6xl px-5">
      <ModuleHeader title={module.title} subtitle={module.subtitle} />
      <div className="mt-8 flex snap-x gap-4 overflow-x-auto pb-4 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {images.map((img, i) => (
          <div
            key={i}
            data-testid={`gallery-img-${i}`}
            className="aspect-[4/5] w-[60vw] max-w-[260px] shrink-0 snap-center overflow-hidden rounded-2xl border border-amber-200/15 bg-gradient-to-br from-[#161d3b] to-[#0a0f24] sm:w-[240px]"
          >
            {img ? (
              <img src={resolveMedia(img)} alt="" loading="lazy" className="h-full w-full object-cover" />
            ) : (
              <div className="grid h-full w-full place-items-center text-amber-300/40">
                <ImageIcon className="h-8 w-8" />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
